module.exports = __webpack_public_path__ + "static/media/piper-2-big-background.675e8186.svg";